"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderedThumbnail = exports.ActiveThumbnail = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactPdf = require("react-pdf");
var _templateObject, _templateObject2;
var ActiveThumbnail = exports.ActiveThumbnail = (0, _styledComponents["default"])(_reactPdf.Thumbnail)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  z-index: 1;\n  opacity: ", ";\n  position: absolute !important;\n  cursor: default;\n  pointer-events: none;\n  canvas.react-pdf__Thumbnail__page__canvas {\n    width: ", ";\n    height: ", ";\n  }\n  div.react-pdf__Thumbnail__page {\n    background-color: #dfe3ec !important;\n  }\n"])), function (props) {
  return props.isLoading ? '0' : '1';
}, function (props) {
  return "".concat(props.presentationDimension.width, "px!important");
}, function (props) {
  return "".concat(props.presentationDimension.height, "px!important");
});
var RenderedThumbnail = exports.RenderedThumbnail = (0, _styledComponents["default"])(_reactPdf.Thumbnail)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: default;\n  pointer-events: none;\n  canvas.react-pdf__Thumbnail__page__canvas {\n    width: ", ";\n    height: ", ";\n  }\n  position: relative !important;\n  div.react-pdf__Thumbnail__page {\n    background-color: #dfe3ec !important;\n  }\n"])), function (props) {
  return "".concat(props.presentationDimension.width, "px!important");
}, function (props) {
  return "".concat(props.presentationDimension.height, "px!important");
});